<div class="pageheader">
    <div class="page-title">
        <h1>Tracking Search</h1>
    </div>
</div>

<div class="container container-fixed tracking-search_container">
    <div class="row">
        <div class="col-sm-4">
            <div class="row">
                <div class="form-group col-md-12">
                    <label title="Main number of the document. E.g. Order Number if order or Invoice Number if Invoice">
                        Document Number
                    </label>
                    <input id="inputDocumentNumber" type="text" class="form-control"
                        [(ngModel)]="searchObject.documentNumber" (keyup.enter)="search()" autofocus
                        [bizFocus]="true" />
                </div>
            </div>
        </div>

        <div class="col-sm-4">
            <label title="The last processing status the document is in">Status Type</label>
            <select id="selectStatusType" class="form-control" [(ngModel)]="searchObject.statusTypeId">
                <option [ngValue]="null">All</option>
                @for (statusType of statusTypes(); track statusType.StatusTypesId) {
                <option [ngValue]="statusType.StatusTypesId">
                    {{ statusType.StatusTypeName }}
                </option>
                }
            </select>
        </div>

        <div class="col-sm-4">
            <ep-distribution-object-selector #distributionObjectSelector [showSearchForUnknown]="true"
                [includeOnlyUsableForDistributions]="false"
                (selectedDistributionObjectChange)="distributionObjectChanged($event)"
                (selectedDistributionObjectGroupChange)="distributionObjectGroupChanged($event)"></ep-distribution-object-selector>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-4 form-group">
            <label>From</label>
            <ep-datetime-picker #datepickerFrom type="datetime"
                (selectedDatetimeChange)="dateFromChanged($event)"></ep-datetime-picker>
        </div>

        <div class="col-sm-4 form-group">
            <label>To</label>
            <ep-datetime-picker #datepickerTo type="datetime"
                (selectedDatetimeChange)="dateToChanged($event)"></ep-datetime-picker>
        </div>

        <div class="col-sm-4 form-group">
            <label>&nbsp;</label>
            <div>
                <button class="btn btn-link" type="button" (click)="setTimeSpan('today')">Today</button>
                <button class="btn btn-link" type="button" (click)="setTimeSpan('last7days')">Last 7 days</button>
                <button class="btn btn-link" type="button" (click)="setTimeSpan('last30days')">Last 30 days</button>
            </div>
        </div>
    </div>

    <dx-accordion class="tracking-search_accordion" #accordion id="accordion-container" [collapsible]="true"
        [multiple]="true" [animationDuration]="300" (onSelectionChanged)="onAccordionSelectionChanged($event)">

        <div *dxTemplate="let item of 'title'">
            <h2>
                <span>{{ item.title }}</span>

                @if(getAccordionCount(item.title) > 0 && isSectionClosed(item.title)) {
                <span>&nbsp;</span>
                <span class="badge bg-badge text-white tracking-search_badge" aria-label="Count">
                    {{ getAccordionCount(item.title) }}
                </span>
                }
            </h2>
        </div>

        <dxi-item title="Partner">
            <div class="row" aria-label="Partner Search">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label title="Search by specific partner">Sending Partner</label>
                        <ep-partner-selector #partnerSelectorFrom
                            (selectedPartnerIdChange)="searchObject.partnerIdFrom = $event; updateSectionCounts()"></ep-partner-selector>
                    </div>
                    <ep-document-type-selector #docTypeIn direction="In"
                        [titleText]="'Search by a specific format/variant/version'"
                        (documentTypeChange)="documentTypeInChanged($event);"></ep-document-type-selector>
                </div>

                <div class="col-sm-6">
                    <div class="form-group">
                        <label title="Search by specific partner">Receiving Partner</label>
                        <ep-partner-selector #partnerSelectorTo
                            (selectedPartnerIdChange)="searchObject.partnerIdTo = $event; updateSectionCounts()"></ep-partner-selector>
                    </div>
                    <ep-document-type-selector #docTypeOut direction="Out"
                        [titleText]="'Search by a specific format/variant/version'"
                        (documentTypeChange)="documentTypeOutChanged($event);"></ep-document-type-selector>
                </div>
            </div>
        </dxi-item>

        <dxi-item title="Error">
            <div class="row" aria-label="Error Search">
                <div class="form-group col-sm-4">
                    <label for="stakeholderSelect">Stakeholder</label>
                    <select id="stakeholderSelect" class="form-control"
                        [(ngModel)]="searchObject.stakeholderUserGroupId" (ngModelChange)="updateSectionCounts()">
                        <option [ngValue]="null">All</option>
                        @for (stakeholder of stakeholders(); track stakeholder.StakeholdersId) {
                        <option [ngValue]="stakeholder.StakeholdersId">
                            {{ stakeholder.Name }}
                        </option>
                        }
                    </select>
                </div>

                <div class="form-group col-sm-4">
                    <label for="errorCodeInput">Error Code</label>
                    <input id="errorCodeInput" class="form-control" type="text" [(ngModel)]="searchObject.errorCode"
                        (ngModelChange)="updateSectionCounts()" (keyup.enter)="search()" />
                </div>

                <div class="form-group col-sm-4">
                    <label for="exceptionMessageInput">Exception Message</label>
                    <input id="exceptionMessageInput" class="form-control" type="text"
                        [(ngModel)]="searchObject.exceptionMessage" (ngModelChange)="updateSectionCounts()"
                        (keyup.enter)="search()" />
                </div>
            </div>
        </dxi-item>

        <dxi-item title="Advanced Search">
            <div class="row" aria-label="Advanced Search">
                <div class="form-group col-sm-4">
                    <label title="Link unique id for a document">Document Id</label>
                    <input id="inputDocumentId" type="number" class="form-control" [(ngModel)]="searchObject.documentId"
                        (ngModelChange)="updateSectionCounts()" (keyup.enter)="search()" />
                </div>
                <div class="form-group col-sm-4">
                    <label
                        title="Number of the in- or outgoing number of the Interchange/file. Always present for Edifact files, optional in other format types">
                        Interchange Number
                    </label>
                    <input id="inputInterchangeNumber" type="text" class="form-control"
                        (ngModelChange)="updateSectionCounts()" [(ngModel)]="searchObject.interchangeNumber"
                        (keyup.enter)="search()" />
                </div>
                <div class="form-group col-sm-4">
                    <label
                        title="If several messages are in one interchange, each will need a unique message number. Always present for Edifact but optional in other formats">
                        Message Number
                    </label>
                    <input id="inputMessageNumber" type="text" class="form-control"
                        [(ngModel)]="searchObject.messageNumber" (ngModelChange)="updateSectionCounts()"
                        (keyup.enter)="search()" />
                </div>
            </div>

            <div class="row" aria-label="Advanced Search">
                <div class="form-group col-sm-4">
                    <label title="Display address/URI of the in- or outgoing transport address">Display Address</label>
                    <input id="inputDisplayAddress" type="text" class="form-control"
                        [(ngModel)]="searchObject.displayAddress" (ngModelChange)="updateSectionCounts()"
                        (keyup.enter)="search()" />
                </div>
                <div class="form-group col-sm-4">
                    <label
                        title="Filename of in- or outgoing file. Depending on transport the sender/recipient might not now this">
                        Filename
                    </label>
                    <input id="inputFilename" type="text" class="form-control" [(ngModel)]="searchObject.filename"
                        (ngModelChange)="updateSectionCounts()" (keyup.enter)="search()" (blur)="trimFilename()" />
                </div>
                <div class="form-group col-sm-4">
                    <label title="Link unique id to identify the distribution used to process the document">
                        Distribution Id
                    </label>
                    <input id="inputDistributionId" type="number" class="form-control"
                        [(ngModel)]="searchObject.distributionId" (ngModelChange)="updateSectionCounts()"
                        (keyup.enter)="search()" />
                </div>
            </div>

            <div class="row" aria-label="Advanced Search">
                <div class="form-group col-sm-4">
                    <label title="Guid identifying the in- or outgoing Interchange/file">Interchange Guid</label>
                    <input id="inputInterchangeGuid" type="text" class="form-control"
                        [(ngModel)]="searchObject.interchangeGuid" (ngModelChange)="updateSectionCounts()"
                        (keyup.enter)="search()" />
                </div>
                <div class="form-group col-sm-4">
                    <label title="Link generated Guid identifying the message/document">Message Guid</label>
                    <input id="inputMessageGuid" type="text" class="form-control" [(ngModel)]="searchObject.messageGuid"
                        (ngModelChange)="updateSectionCounts()" (keyup.enter)="search()" />
                </div>
                <div class="form-group col-sm-4">
                    <label title="Id of the incoming or outgoing transmission">Transmission ID</label>
                    <input id="inputTransmissionId" type="text" class="form-control"
                        [(ngModel)]="searchObject.transmissionId" (ngModelChange)="updateSectionCounts()"
                        (keyup.enter)="search()" />
                </div>
            </div>

            <div class="row" aria-label="Advanced Search">
                <div class="form-group col-sm-4">
                    <label title="Guid identifying the document">Document Guid</label>
                    <input id="inputDocumentGuid" type="text" class="form-control"
                        [(ngModel)]="searchObject.documentGuid" (ngModelChange)="updateSectionCounts()"
                        (keyup.enter)="search()" />
                </div>
                <div class="form-group col-sm-4">
                    <label title="Originating ID for Interchange or Document">Originating ID</label>
                    <input id="inputOriginatingId" type="text" class="form-control"
                        [(ngModel)]="searchObject.originatingId" (ngModelChange)="updateSectionCounts()"
                        (keyup.enter)="search()" />
                </div>
                <div class="form-group col-sm-4">
                    <label title="Partner system of the in- or outgoing Interchange/file">Partner System</label>
                    <select id="selectPartnerSystem" class="form-control" [(ngModel)]="searchObject.partnerSystemId"
                        (ngModelChange)="updateSectionCounts()">
                        <option [ngValue]="null">All</option>
                        @for (partnerSystem of partnerSystems(); track partnerSystem.Id) {
                        <option [ngValue]="partnerSystem.Id">
                            {{ partnerSystem.Name }}
                        </option>
                        }
                    </select>
                </div>
            </div>
        </dxi-item>

        <dxi-item title="Tracking Fields" [visible]="isTrackingFieldsVisible()">
            <div class="row" aria-label="Tracking Fields">
                <div class="form-group col-sm-12">
                    <ep-datafield-group-container #trackingFieldContainer [datafieldGroups]="trackingFieldGroups()"
                        (changes)="updateSectionCounts()" [isAlwaysEditable]="true"
                        [numberOfColumns]="3"></ep-datafield-group-container>
                </div>
            </div>
        </dxi-item>
    </dx-accordion>
    <br>
    <div class="row">
        <div class="col-sm-12">
            <button class="btn btn-primary" type="button" (click)="search()" id="searchButton">Search</button>
            <button class="btn btn-link" type="button" (click)="reset()" id="clearButton">
                Reset search
                <ep-svg-icon icon="circle-cross"></ep-svg-icon>
            </button>
        </div>
    </div>
</div>